
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/monetization-terms",
      function () {
        return require("private-next-pages/legal/monetization-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/monetization-terms"])
      });
    }
  